import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatCheckboxChange} from '@angular/material';
import {FormConfig} from '../../models/form-config';
import {FormFactoryService} from '../../services/form-factory.service';
import {AbstractControl, FormGroup} from '@angular/forms';
import {GA4EventKey} from '../../../core/consts/ga4-event-key.enum';
import {GoogleAnalyticsEventsService} from '../../services/google-analytics-events.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-checkboxes-group',
  templateUrl: './checkboxes-group.component.html',
  styleUrls: []
})
export class CheckboxesGroupComponent implements OnInit, AfterViewInit {

  @Input() config: CheckboxesGroupConfig;
  @Input() bean: any;
  @Input() formConfig: FormConfig;
  @Input() fieldKeys: string[];
  @Input() formFactoryService: FormFactoryService;
  @Input() formGroup: FormGroup;
  @Input() checkAllButtonAlwaysVisible: boolean = false;

  @Output() checkAllChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() checkAllClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() checkboxChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkboxInteractiveClick: EventEmitter<any> = new EventEmitter<any>();

  allChecked: boolean = false;

  get checkAllButtonVisible(): boolean {
    return this.config && !!this.config.checkAllLabel && (this.checkAllButtonAlwaysVisible || this.fieldKeys.length > 1);
  }

  get controls(): AbstractControl[] {
    return this.fieldKeys.map(fieldKey => this.formGroup.controls[fieldKey]);
  }

  constructor(private googleAnalyticsService: GoogleAnalyticsEventsService,
              private translateService: TranslateService) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.updateAllChecked();
  }

  onCheckAllChange(event: MatCheckboxChange): void {
    const { checked } = event;
    this.checkAllChange.emit(checked);
    this.allChecked = checked;
    this.controls.forEach(control => control.setValue(checked));
  }

  onCheckAllClick(): void {
    setTimeout(() => {
      this.checkAllClick.emit(this.allChecked);
      this.onCheckboxInteractiveClick({
        fieldLabel: this.translateService.instant(this.config.checkAllLabel)
      });
      this.googleAnalyticsService.send(GA4EventKey.FIELD_CLICK, {
        calculator_field_name: this.translateService.instant(this.config.checkAllLabel),
        calculator_field_value: this.allChecked
      });
    }, 0);
  }

  onCheckboxChange(event: any): void {
    this.checkboxChange.emit(event);
    this.updateAllChecked();
  }

  onCheckboxInteractiveClick(event: any): void {
    this.checkboxInteractiveClick.emit(event);
  }

  updateAllChecked(): void {
    this.allChecked = this.controls.map(control => control.value).every(checked => checked);
  }

}

export interface CheckboxesGroupConfig {
  checkAllLabel: string;
}
